export const PREDEFINED_URLS = ["preprod-tastio.com", "my.tastio.com", "localhost:4200", "localhost:5000", "localhost:4"];